// eslint-disable-next-line
// @ts-nocheck
import getResource from '../../core/resources';
import SvgManager from '../../core/SvgManager';
import { getFormMetadata } from './formMetadata';
import { getFormValues } from './formValues';

const images = {
	folder: '../images/Folder.svg',
	form: '../images/Form.svg',
	itemType: '../images/ItemType.svg',
	page: '../images/File.svg',
	sort: '../images/NavContentsOn.svg',
	item: '../images/DefaultItemType.svg'
};
SvgManager.enqueue(Object.values(images));

const generateFormData = (stateData, state, form) => {
	const { order } = form;
	const metadata = getFormMetadata(stateData, state, order);
	const data = getFormValues(stateData, state, order);

	return { ...form, data, metadata };
};

const getSortingFormData = () => {
	const image = images.sort;
	const label = getResource('toc_editor.toc');
	const order = ['sort'];

	return {
		image,
		label,
		order
	};
};

const getCategoryFormData = () => {
	const image = images.folder;
	const label = getResource('toc_editor.category');
	const order = ['label'];

	return {
		image,
		label,
		order
	};
};

const getItemTypeFormData = () => {
	const image = images.itemType;
	const label = getResource('toc_editor.itemtype');
	const order = ['itemType', 'image', 'label', 'access'];

	return {
		image,
		label,
		order
	};
};

const getPageDashboardFormData = () => {
	const image = images.page;
	const label = getResource('toc_editor.page');
	const order = ['startPage', 'parameters', 'image', 'label', 'access'];

	return {
		image,
		label,
		order
	};
};

const getItemFormData = () => {
	const image = images.item;
	const label = 'Item';
	const order = ['itemType', 'item', 'image', 'label', 'access'];

	return {
		image,
		label,
		order
	};
};

const getFormDashboardFormData = () => {
	const image = images.form;
	const label = getResource('toc_editor.form');
	const order = ['form', 'image', 'label', 'access'];

	return {
		image,
		label,
		order
	};
};

export const getFormData = (data, state) => {
	const { selectedId } = state;
	if (!selectedId) {
		const formData = getSortingFormData();
		return generateFormData(data, state, formData);
	}

	const relshipItem = data.get(selectedId);
	if (!relshipItem) {
		return null;
	}

	let formData = null;
	const relatedItem = data.get(relshipItem.related_id) ?? {};
	const { '@odata.type': type, additional_data: additionalData } = relatedItem;
	if (type === '#CommandBarMenu') {
		formData = getCategoryFormData();
	} else if (additionalData?.itemId !== undefined) {
		formData = getItemFormData();
	} else if (additionalData?.startPage !== undefined) {
		formData = getPageDashboardFormData();
	} else if (additionalData?.itemTypeId) {
		formData = getItemTypeFormData();
	} else if (additionalData?.formId) {
		formData = getFormDashboardFormData();
	}

	if (formData) {
		return generateFormData(data, state, formData);
	}

	return formData;
};

const getItemChange = (propName, newValue, state) => {
	const { itemId, label } = newValue;
	switch (propName) {
		case 'access':
			return {
				'role@aras.id': itemId,
				'role@aras.keyed_name': label
			};
		case 'itemType': {
			const additionalData = getAdditionalData(state);

			const change = {
				additional_data: {
					...additionalData,
					itemTypeId: itemId
				}
			};

			const isItemTypeWasChanged = additionalData.itemTypeId !== itemId;
			if (change.additional_data.itemId !== undefined && isItemTypeWasChanged) {
				change.additional_data.itemId = null;
			}

			return change;
		}
		case 'form': {
			const additionalData = getAdditionalData(state);

			return {
				additional_data: {
					...additionalData,
					formId: itemId
				}
			};
		}
		case 'item': {
			const additionalData = getAdditionalData(state);

			return {
				additional_data: {
					...additionalData,
					itemId
				}
			};
		}
		default:
			return null;
	}
};

const getAdditionalData = (state) => {
	const { selectedId, tocData, changes } = state;
	const relshipItem = tocData.get(selectedId);
	const relatedId = relshipItem?.related_id;
	const relatedItem = tocData.get(relatedId);
	const changedRelatedId = relatedId ?? changes[selectedId].related_id;
	const changedRelatedItem = changes[changedRelatedId];
	const additionalData = {
		...relatedItem?.additional_data,
		...changedRelatedItem?.additional_data
	};

	return additionalData;
};

export const getFormChange = (form, state, detail) => {
	const { newValue, propName } = detail;
	const type = form.metadata[propName]?.type;
	switch (type) {
		case 'multiLingual': {
			const { defaultLanguageCode } = state;
			return Object.entries(newValue).reduce((change, [code, value]) => {
				if (code === defaultLanguageCode) {
					change[propName] = value;
				}
				change[`${propName}@aras.lang.${code}`] = value;
				return change;
			}, {});
		}
		case 'item': {
			return getItemChange(propName, newValue, state);
		}
		case 'image': {
			return { image: newValue };
		}
		case 'select': {
			return { sortingType: newValue };
		}
		case 'text': {
			const additionalData = getAdditionalData(state);

			return {
				additional_data: {
					...additionalData,
					[propName]: newValue
				}
			};
		}
		default:
			return null;
	}
};
